export const advisors = [
    {
        id : 1,
        name : 'Advisor 1',
        title: 'General Partner,  NFT Platform',
        text: '',
        image: 'team/pfp.png',
        socials: {
            twitter : 'https://twitter.com/',
            discord : '',
            github : '',
            email : '',
            linkedin : 'https://www.linkedin.com/in/',
        }
    },
    {
        id : 2,
        name : 'Advisor 2',
        title: 'Co-founder, Blockchain contributor',
        text: '',
        image: 'team/pfp.png',
        socials: {
            twitter : 'https://twitter.com/',
            discord : '',
            github : 'https://github.com/',
            email : '',
            linkedin : 'https://www.linkedin.com/in/',
        }
    },
    {
        id : 3,
        name : 'Advisor 3',
        title: 'Co-creator, Blockchain contributor',
        text: '',
        image: 'team/pfp.png',
        socials: {
            twitter : 'https://twitter.com/',
            discord : '',
            github : 'https://github.com/',
            email : '',
            linkedin : 'https://www.linkedin.com/in/',
        }
    },
    
]
